import { ProviderEnum } from "api";
import { useState } from "react";
import { toast } from "sonner";
import { config } from "../../app.config";

interface SendReceiptPayload {
  orderId: string;
  email: string;
  channel: ProviderEnum;
  businessId?: string;
}

export function useSendReceipt() {
  const [isLoading, setIsLoading] = useState(false);

  const sendReceipt = async (payload: SendReceiptPayload) => {
    setIsLoading(true);

    try {
      const response = await fetch(config.cloudFunctions.receiptUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to send receipt");
      }

      toast.success("Receipt sent successfully!");
    } catch (err) {
      toast.error("Failed to send receipt");
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const sendPosReceipt = async (
    orderId: string,
    email: string,
    businessId: string
  ) => {
    return sendReceipt({
      orderId,
      email,
      channel: ProviderEnum.MunchiPos,
      businessId,
    });
  };

  const sendOnlineReceipt = async (
    orderId: string,
    email: string,
    provider: ProviderEnum,
    businessId: string
  ) => {
    return sendReceipt({
      orderId,
      email,
      channel: provider,
      businessId,
    });
  };

  const sendKioskReceipt = async (
    orderId: string,
    email: string,
    businessId: string,
    provider: ProviderEnum.MunchiKiosk | ProviderEnum.Kiosk
  ) => {
    return sendReceipt({
      orderId,
      email,
      channel: provider,
      businessId,
    });
  };

  return {
    sendPosReceipt,
    sendOnlineReceipt,
    sendKioskReceipt,
    isLoading,
  };
}
